{
  "tableData": [
    {
      "id": "1",
      "name": "Broschüre XERION 12 Series HRC MOCK.pdf",
      "language": "DE",
      "format": "PDF",
      "size": "8.4MB",
      "path": "../../Broschüre_XERION_12_Series_HRC_MOCK.pdf"
    },
    {
      "id": "2",
      "name": "Broschüre XERION 12 Series HRC MOCK.pdf",
      "language": "DE",
      "format": "PDF",
      "size": "8.4MB",
      "path": "../../Broschüre_XERION_12_Series_HRC_MOCK.pdf"
    },
    {
      "id": "3",
      "name": "Broschüre XERION 12 Series HRC MOCK.pdf",
      "language": "DE",
      "format": "PDF",
      "size": "8.4MB",
      "path": "../../Broschüre_XERION_12_Series_HRC_MOCK.pdf"
    },
    {
      "id": "4",
      "name": "Broschüre XERION 12 Series HRC MOCK.pdf",
      "language": "DE",
      "format": "PDF",
      "size": "8.4MB",
      "path": "../../Broschüre_XERION_12_Series_HRC_MOCK.pdf"
    }
  ]
}
